export default __webpack_public_path__ + "static/media/planning.77369ab6.svg";